import { createFilterSlice, FilterSlice } from 'hooks/state/FilterSlice';
import { create } from 'zustand/react';
import { searchParamsStorage } from 'hooks/state/UrlPersistence';
import { createJSONStorage, persist } from 'zustand/middleware';
import { parseISO } from 'date-fns';
import { timeZoneSafeDateString } from 'utils/dateUtils';
import { BenchmarkingDateValue } from 'components/filter/modules/benchmarking';
import { recalcDatesFromPresets } from 'components/filter/input/DateRangePicker/presets/resolvers';

type AppStore = FilterSlice;

export const useAppStore = create<AppStore>()(
  persist((...a) => createFilterSlice(...a), {
    name: 'state',
    storage: createJSONStorage(() => searchParamsStorage, {
      replacer(key) {
        // @ts-expect-error as per docs
        const v = this[key] as unknown;

        if (v instanceof Date) {
          return { date_type: 'Date', value: timeZoneSafeDateString(v) };
        }

        return v;
      },
      reviver(_, value) {
        if ((value as { date_type?: string })?.date_type === 'Date') {
          // @ts-expect-error as per docs
          return parseISO(value.value as string);
        }

        return value;
      },
    }),
    onRehydrateStorage: _state => {
      return state => {
        if (state) {
          state.setDateRange(recalcDatesFromPresets(state.dateRange));
          state.setCreationDateRange(recalcDatesFromPresets(state.creationDateRange));
          state.setBenchmarkingDateRange(recalcDatesFromPresets(state.benchmarkingDateRange) as BenchmarkingDateValue);
        }
      };
    },
  })
);
